import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import { useSelector } from 'react-redux';
import { StyledLeadContainer } from '../../Components/Styled/index';
import { handleValidateCodevalue } from '../../Utility/constant';
import { workflowActionType, workflowProcessingTypes, workflowStatus, searchWorkflowTriggerTypes } from '../../Utility/workflowConfig';
import { WhoColumns } from '../../Components/WhoColumns';
import TextFiledWithLabel from '../../Components/TextFieldWithLabel';
import './workflow.css';

const SearchWorkflowComponent = ({ entityDetails, handleOnChange }) => {
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);

    return (
        <Box className="workflow-search-fields">
            <StyledLeadContainer>
                <TextFiledWithLabel
                    name="name"
                    value={entityDetails?.name || ''}
                    label={handleValidateCodevalue(internationalise, 'WF_SEARCH_NAME')}
                    handleOnChange={handleOnChange}
                />
                <TextFiledWithLabel
                    id="status"
                    select
                    name="status"
                    label={handleValidateCodevalue(internationalise, 'WF_SEARCH_STATUS')}
                    value={entityDetails?.status || ''}
                    onChange={handleOnChange}
                >
                    {workflowStatus?.map((option) => (
                        <MenuItem key={option?.label} value={option?.label}>
                            {handleValidateCodevalue(internationalise, option?.label)}
                        </MenuItem>
                    ))}
                </TextFiledWithLabel>
                <TextFiledWithLabel
                    id="triggerType"
                    select
                    name="triggerType"
                    label={handleValidateCodevalue(internationalise, 'WF_SEARCH_TRIGGER_TYPE')}
                    value={entityDetails?.triggerType || ''}
                    onChange={handleOnChange}
                >
                    {searchWorkflowTriggerTypes?.map((option) => (
                        <MenuItem key={option?.value} value={option?.value}>
                            {handleValidateCodevalue(internationalise, option?.label)}
                        </MenuItem>
                    ))}
                </TextFiledWithLabel>
                <TextFiledWithLabel
                    id="processingType"
                    select
                    name="processingType"
                    label={handleValidateCodevalue(internationalise, 'WF_SEARCH_PROCESSING_TYPE')}
                    value={entityDetails?.processingType || ''}
                    onChange={handleOnChange}
                >
                    {workflowProcessingTypes?.map((option) => (
                        <MenuItem key={option?.value} value={option?.value}>
                            {handleValidateCodevalue(internationalise, option?.label)}
                        </MenuItem>
                    ))}
                </TextFiledWithLabel>
                <TextFiledWithLabel
                    id="actionType"
                    select
                    name="actionType"
                    label={handleValidateCodevalue(internationalise, 'WF_SEARCH_ACTION_TYPE')}
                    value={entityDetails?.actionType || ''}
                    onChange={handleOnChange}
                >
                    {workflowActionType?.map((option) => (
                        <MenuItem key={option?.value} value={option?.value}>
                            {handleValidateCodevalue(internationalise, option?.label)}
                        </MenuItem>
                    ))}
                </TextFiledWithLabel>
            </StyledLeadContainer>
            <WhoColumns
                searchState={entityDetails}
                handleOnChange={handleOnChange}
            />
        </Box>
    );
}

export default SearchWorkflowComponent;
